import React from 'react'
import PropTypes from 'prop-types'
import { DialogBox, Close, Header, Content} from './styled'

export const Dialogv2 = props => {
    const {isOpen, children, handleClose, title} = props

    return <DialogBox error={props.error} open={isOpen} classes={{paper: 'dialog'}}>
            <Header >{title}{handleClose && <Close onClick={() => handleClose(false)}>&times;</Close>}</Header>
            <Content>{children}</Content>
        </DialogBox>
}

Dialogv2.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    handleClose: PropTypes.any,
}